var map = {
	"./1People.png": 5443,
	"./Artelize.png": 8971,
	"./Concordium.png": 7701,
	"./DoLand.png": 8460,
	"./FairBusinessGrowth.png": 1352,
	"./FairMedia.png": 9048,
	"./FairShop.png": 1354,
	"./LoveNature.png": 8439,
	"./Valified.png": 302,
	"./WL.png": 1957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3709;